<template>
    <div :id="idFormulario" class="form-registro-empresas-sinoj">
        <h5 style="margin-bottom: 1em;" v-html="instrucciones"></h5>
        <div id="formulario-datos-empresa" class="contenedor-color-negro">
            <h6>Datos de la Empresa o Institución</h6>
            <hr style="height:1px;border:none;color:var(--verde-pj-100);background-color:var(--verde-pj-100);" class="mt-0"/>
            <div class="row">
                <div class="for-group col-6">
                    <h6>Nombre de la Empresa o Institución&nbsp;
                        <i v-if="mostrarErroresEnFormulario && !this.cadenaEsVaciaONula(nombreEmpresa)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                        <i v-if="mostrarErroresEnFormulario && this.cadenaEsVaciaONula(nombreEmpresa)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                    <input v-model="nombreEmpresa" type="text" :id="idFormulario + 'nombre-empresa'" :class="[mostrarErroresEnFormulario && this.cadenaEsVaciaONula(nombreEmpresa) ? 'form-control border border-danger' : 'form-control']" placeholder="Ingrese el nombre de la empresa o institucion" />
                </div>
                <div class="for-group col-6 pl-1">
                    <h6>Notificador asignado (opcional)</h6>
                    <C020Notificadores class="p-0 m-0" 
                        v-on:valorParaElPadre="evtCambioTipoNotificador" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'CatalogoNotificadores'" 
                        :parametros="parametros_Notificadores.parametros" 
                        :valorDefinido="parametros_Notificadores.valorDefinido" 
                        :key="'CNotVCRE' + contRenderNotificador"
                        :filtrarPorJurisdiccion="true"
                        :ref="idFormulario + REF_NOTIFICADORES"></C020Notificadores>
                </div>
            </div>
             <div id="contenedor-error-formulario" v-if="mostrarErroresEnFormulario && domicilios.length < 1">
                <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en formulario [Domicilio]</h6>
                <span style="text-align: justify; display:block;">Debes tener al menos un domicilio agregado</span>
            </div>
            <CFormularioDomicilio 
                :idFormulario="'FormEmpresaDomicilio'"
                :valorDefinidoFraccionamientos="valorDefinidoCfraccionamientoP"
                :contadorRenderCatalogo="contadorRenderCatalogoP"
                :valorDefinidoMunicipios="valDefCM"
                :contadorRenderCatalogoMunicipio="contRenderCM"
                :herramientas="{ domicilioConPuntero: false, ubicarDomicilioEnMapa: true }"
                v-on:obtenerListadoDeDomicilios="evtObtenerDomicilios"
                v-on:obtenerContRenderC="contadorRenderCatalogoP = $event"
                v-on:obtenerValorDefinidoCF="valorDefinidoCfraccionamientoP = $event"
                v-on:obtenerContRenderCM="contRenderCM = $event"
                v-on:obtenerValorDefinidoCM="valDefCM = $event"
                :key="'FDomK' + contRenderFormularios"
                :ref="idFormulario + REF_DOMICILIOS"></CFormularioDomicilio>
        </div>
        <!--  MOSTRAR ERRORES CUANDO REPRESENTANTE LEGAL ES OBLIGATORIO
            <div id="contenedor-error-formulario" v-if="mostrarErroresEnFormulario && representantesLegales.length < 1">
            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en formulario [Representante Legal]</h6>
            <span style="text-align: justify; display:block;">Debes tener al menos un representante legal agregado</span>
        </div> -->
        <div id="formulario-representante-empresa" class="contenedor-color-negro" style="margin-top: 1.5em;">
            <CFormularioRepresentantesLegales 
                :idFormulario="'FormRepresentantes'"                
                v-on:obtenerListadoDeRepresentantesLegales="evtObtenerRepresentantes"
                :key="'FRLK' + contRenderFormularios"
                :ref="idFormulario + REF_REPRESENTANTES"></CFormularioRepresentantesLegales>
        </div>
        <div v-if="implementarGuardado" class="text-right">
            <div style="margin-top: 2em;">
                <button type="button" @click="evtGuardarEmpresa" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar Empresa</button>
            </div> 
        </div>
    </div>
</template>
<script>
import CMapaDeDomicilios from '../Comun/CMapaDeDomicilios.vue'
import CFormularioDomicilio from '../Comun/CFormularioDomicilio.vue'
import CFormularioRepresentantesLegales from '../Comun/CFormularioRepresentantesLegales.vue'
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    components: {
        CMapaDeDomicilios: CMapaDeDomicilios,
        C019Fraccionamientos: catalogos.SINOJ.C019Fraccionamientos,
        CFormularioDomicilio: CFormularioDomicilio,
        CFormularioRepresentantesLegales: CFormularioRepresentantesLegales,
        C020Notificadores: catalogos.SINOJ.C020Notificadores,
    },
    props: {
        idFormulario: String,
        instrucciones: String,
        implementarGuardado: Boolean,
        empresa: Object,
        mostrarErroresEnFormulario: Boolean
    },
    data() {
        return {
            enumeraciones,
            contadorRenderCatalogoP: 0, 
            valorDefinidoCfraccionamientoP: -1, 
            contRenderCM: 0, 
            valDefCM: -1,
            representantesLegales: [],
            domicilios: [],
            nombreEmpresa: null,
            empresaEntidadObj: null,
            contRenderFormularios: 0,
            REF_DOMICILIOS: 'RefDomiciliosForm',
            REF_REPRESENTANTES: 'RefRepresentantesForm',
            REF_NOTIFICADORES: 'RefNotificadoresForm',
            parametros_Notificadores: {
                parametros: { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAreaDeUsuario: true, ConAsignacionDeFraccionamientos: false },
                valorDefinido: -1
            },
            tipoNotificadorId: -1,
            contRenderNotificador: 0 
        }
    },
    methods: {
        evtCambioTipoNotificador: function(evento) {
            const TIPO_NOTIFICADOR_ID = parseInt(evento.target.value);
            this.tipoNotificadorId = (TIPO_NOTIFICADOR_ID > 0) ? TIPO_NOTIFICADOR_ID : -1;
        },
        evtObtenerDomicilios: function(evento) { 
            this.domicilios = evento;
            this.empresa_entidad = null;
            this.empresa_entidad = this.crearObjetoEmpresa();
        },
        evtObtenerRepresentantes: function(evento) {
            this.representantesLegales = evento;
            this.empresa_entidad = null;
            this.empresa_entidad = this.crearObjetoEmpresa();
        },
        evtCambioNombre: function() {
            this.empresa_entidad = null;
            this.empresa_entidad = this.crearObjetoEmpresa();
        },
        evtGuardarEmpresa: function() { 
            if(this.empresaEstaCompleta()){
                this.empresaEntidadObj = this.crearObjetoEmpresa();
                let peticionAPI = {
                    Empresa: this.empresaEntidadObj,
                    EsPrueba: false
                }                
                this.guardarEmpresaBD(peticionAPI);                
            }
            else {
                this.mostrar_errores = true;
                comun.mensajeDeAlerta('se detectaron campos incorrectos', null, null);
            }
        },
        guardarEmpresaBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.administracion.empresas.GuardarNuevaEmpresa;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        comun.SeEstaCargandoInformacion(false);
                        // eliminar log despues de pruebas en desarrollo
                        //console.log("obtenerUsuariosPorArea::ejecuto bien:: ",respuesta.data);
                        this.limpiarVariablesFormularios();
                         this.contRenderNotificador ++;
                        this.contRenderFormularios ++;
                        this.mostrar_errores = false;
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.$emit('evtActualizarCatalogo',respuesta.data.Empresa);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
            ); 
        },
        limpiarVariablesFormularios: function() {
            this.contadorRenderCatalogoP = 0;
            this.valorDefinidoCfraccionamientoP = -1; 
            this.contRenderCM = 0;
            this.valDefCM = -1;
            this.nombreEmpresa = null;
            this.representantesLegales = [];
            this.domicilios = [];
            this.empresaEntidadObj = null;
        },
        crearObjetoEmpresa: function() { 
            let empresa = {};
            empresa.EmpresaId = -1;
            empresa.Nombre = this.nombreEmpresa;
            // asignacion de notificador
            empresa.Notificador = (this.tipoNotificadorId > 0) ? { NotificadorId: this.tipoNotificadorId } : null;
            empresa.Activo = true;
            empresa.RepresentantesLegales = this.representantesLegales.map(r => {
                return r.representanteLegal;
            });
            empresa.Domicilios = this.domicilios.map(d => {
                return d.Domicilio;
            });
            return empresa;
        },
        empresaEstaCompleta: function() {
            let empresaCompleta = false;
            /*  validacion cuando es obligatorio un representante legal
                if(!this.cadenaEsVaciaONula(this.nombreEmpresa) && this.representantesLegales.length > 0 && this.domicilios.length > 0) */
            if(!this.cadenaEsVaciaONula(this.nombreEmpresa) && this.domicilios.length > 0)
                empresaCompleta = true;
            return empresaCompleta; 
        },
        evtObtenrListado:function(evento) {
            //console.log('evtObtenrListado::',evento)
        },
        evtAsignacionDomicilios: function(evento) {
            //console.log('evtAsignacionDomicilios::',evento);
        },
         cadenaEsVaciaONula: function(cadena) {
            let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula;
        }
        /* evtPrueba: function(evento,empresaObj) {
            console.log('valorEmpresa::',empresaObj);

        }, */
        /* limpiarDatosDomicilio: function() {
            this.colonia_empresa = null;
            this.codigo_postal = null;
            this.calle_empresa = null;
            this.numero_exterior = null;
            this.numero_interior = null;
            this.informacion_adicional = null;
        },
        evtVerCatalogoFraccionamientos: function() {
            this.visualizarCFraccionamientos = true; 
            this.limpiarDatosDomicilio();
            this.render_catalogo += 1;
            if(this.visualizarMapaDomicilios) {
                this.eliminarMarcador();
                if(this.punteroMarcador) {
                    this.mapaModoVisualizacion();
                }
            }
        },
        evtOcultarCatalogoFraccionamientos: function() {
            this.visualizarCFraccionamientos = false;
            this.limpiarDatosDomicilio();
            if(this.visualizarMapaDomicilios) {
                this.eliminarMarcador();
                if(this.punteroMarcador) {
                    this.mapaModoVisualizacion();
                }
            }
        },
        cambioTipoFraccionamiento: function(evento,fraccionamiento) {
            this.fraccionamientoObj = fraccionamiento;
            if(this.fraccionamientoObj != null) {
                this.colonia_empresa = this.fraccionamientoObj.Nombre;
                this.codigo_postal = this.fraccionamientoObj.CodigoPostal.toString();
               // $("#" + this.idFormulario + 'cp-pf-domicilio').attr('disabled','disabled');
            }
            else {
                this.colonia_empresa = null;
                this.codigo_postal = null;
              //  $("#" + this.idFormulario + 'cp-pf-domicilio').removeAttr('disabled');
            }
            this.$emit('obtenerFraccionamientoFA', this.fraccionamientoObj);
        },
        asignarValoresDeDomicilio: function(evento) {
            console.log('evento::',evento);
            this.colonia_empresa = evento.address.Neighborhood;
            this.codigo_postal = evento.address.Postal;
            this.numero_exterior = evento.address.AddNum;
            this.municipio_colonia = evento.address.Subregion;

            if(this.numeroExterior != "") {
                let informacioncalle = evento.address.Address.split(" ");
                let calle = informacioncalle.slice(0,-1);
                this.calle_empresa = calle.join(" ");
            }
            else {
                this.calle_empresa = evento.address.Address;
            }
            this.datosGeocode = evento;
            this.herramientaDomicilio = true;
        },
        cadenaEsVaciaONula: function(cadena) {
            let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula;
        },
        fraccionamientoEsIncorrecto: function() {
            let fraccionamientoIncorrecto = true;
            if(this.fraccionamientoObj != null) {
                fraccionamientoIncorrecto = false;
            }
            return fraccionamientoIncorrecto;
        },
        agregarDomicilioEnMapa: function() {
            this.visualizarCFraccionamientos = false;
            this.colonia_empresa = null;
            this.codigo_postal = null;
            this.$refs.mapaDomiciliosFormularioEmpresas.seleccionarDomicilio();
            this.punteroMarcador = true;
        },
        mapaModoVisualizacion: function() {
            this.$refs.mapaDomiciliosFormularioEmpresas.seleccionarDomicilio();
            this.punteroMarcador = false;
        },
        visualizarDomicilioEnMapa: function() {
            // let datosDomicilio = {
              //  calle: this.pfCalle,
                //ciudad: 'Aguascalientes',
                //region: 'Aguascalientes',
                //codigoPostal: this.pfCodigoPostal
           // }
            //this.$refs.mapaDomiciliosCreacion.obtenerCoordenadasPorCalle(datosDomicilio); 
            if(!this.cadenaEsVaciaONula(this.colonia_empresa) && !this.cadenaEsVaciaONula(this.codigo_postal) && !this.cadenaEsVaciaONula(this.numero_exterior) && !this.cadenaEsVaciaONula(this.calle)) {
                const domicilioCompleto = this.obtenerDomicilioCompleto();
                this.$refs.mapaDomiciliosFormularioEmpresas.obtenerCoordenadasPorCalleCompleta(domicilioCompleto);
                this.herramientaDomicilio = true;
                this.visualizarErroresUbicacionEnMapa = false;
            }
            else{
                this.visualizarErroresUbicacionEnMapa = true;
                comun.mensajeDeAlerta('La direccion esta incompleta,<br> debes llenar los campos Fraccionamiento, Codigo Postal, Numero Exterior y Calle.', null, null);
            }
        },
        obtenerDomicilioCompleto: function() {
            // formato { calle, fraccionamiento,Municipio, codigo postal, MX }
            let domicilio = `${this.calle} ${this.numeroExterior}, ${this.colonia}, ${this.municipio}, ${this.codigoPostal}, MEX`;
            return domicilio;
        },
        eliminarMarcador: function() {
            this.$refs.mapaDomiciliosFormularioEmpresas.eliminarMarcador();
            this.herramientaDomicilio = false;
        },
        limpiarFormulario: function() {
            this.visualizarMapaDomicilios = false;
        },
        desabilitarCodigoPostal: function() {
            if(this.visualizarCFraccionamientos)
                $("#" + this.idFormulario + 'cp-pf-domicilio').attr('disabled','disabled');

            else
                $("#" + this.idFormulario + 'cp-pf-domicilio').removeAttr('disabled');
        } */
    },
    mounted() {
        $("#" + this.idFormulario + 'nombre-empresa' ).on("change paste keyup", () => {
            this.evtCambioNombre();
        });
        if(this.empresa != null) {
            this.nombreEmpresa = this.empresa.Nombre;
            if(this.empresa.Notificador != null) {
                this.parametros_Notificadores.valorDefinido = this.empresa.Notificador.NotificadorId;
                this.contRenderNotificador ++;
            }
            //console.log('empresa::domicilios::',this.empresa.Domicilios);
            // se asignan valores de domicilio
            if(this.empresa.Domicilios != null && this.empresa.Domicilios.length > 0) {
                this.$refs[this.idFormulario + this.REF_DOMICILIOS].domicilios = this.empresa.Domicilios.map(d => {
                    let domicilioObj = {
                        Domicilio: d,
                        idReferencia: null
                    }
                    return domicilioObj;
                });
                let domiciliosFormatoTabla = [];
                let contDomicilios = 1;
                this.$refs[this.idFormulario + this.REF_DOMICILIOS].domicilios.forEach(d => {
                    d.idReferencia = contDomicilios;
                    let objDomiciloTabla = {
                        Folio: contDomicilios,
                        domicilio: `${d.Domicilio.Calle} ${d.Domicilio.NumeroExterior}, ${d.Domicilio.Fraccionamiento.Nombre}, ${d.Domicilio.Fraccionamiento.Municipio.Nombre}, ${d.Domicilio.Fraccionamiento.CodigoPostal}, MEX`
                    }
                    domiciliosFormatoTabla.push(objDomiciloTabla);
                    contDomicilios ++;
                });
                this.domicilios = this.$refs[this.idFormulario + this.REF_DOMICILIOS].domicilios;
                this.$refs[this.idFormulario + this.REF_DOMICILIOS].domiciliosTabla = domiciliosFormatoTabla;
                this.$refs[this.idFormulario + this.REF_DOMICILIOS].contadorDomicilios = domiciliosFormatoTabla.length;
            }

            // se asignan valores de representantes legales
            if(this.empresa.RepresentantesLegales != null && this.empresa.RepresentantesLegales.length > 0) {
                //console.log('empresa::RepresentantesLegales::',this.empresa.RepresentantesLegales);
                this.$refs[this.idFormulario + this.REF_REPRESENTANTES].representantesLegales = this.empresa.RepresentantesLegales.map(r => {
                    let representanteObj = {
                        representanteLegal: r,
                        idReferencia: null
                    }
                    return representanteObj;
                });
                let representantesFormatoTabla = [];
                let contRepresentantes = 1;
                this.$refs[this.idFormulario + this.REF_REPRESENTANTES].representantesLegales.forEach(r => {
                    r.idReferencia = contRepresentantes;
                    const DATOS_NOMBRE = [r.representanteLegal.DatosGenerales.Fisica.Nombre, r.representanteLegal.DatosGenerales.Fisica.ApellidoPaterno, r.representanteLegal.DatosGenerales.Fisica.ApellidoMaterno]
                    const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                    let objRepresentanteTabla = {
                        Folio: contRepresentantes,
                        Representante: NOMBRE_COMPLETO
                    }
                    representantesFormatoTabla.push(objRepresentanteTabla);
                    contRepresentantes ++;
                });
                this.representantesLegales = this.$refs[this.idFormulario + this.REF_REPRESENTANTES].representantesLegales;
                this.$refs[this.idFormulario + this.REF_REPRESENTANTES].representantesLegalesTabla = representantesFormatoTabla;
                this.$refs[this.idFormulario + this.REF_REPRESENTANTES].contadorRepresentantesLegales = representantesFormatoTabla.length;
                //console.log('ref::rep::',this.$refs[this.idFormulario + this.REF_REPRESENTANTES].representantesLegalesTabla);
            }
        }
    },
    watch: {
        empresaEntidadObj() {

        }
        /* visualizarCFraccionamientos(){
            this.desabilitarCodigoPostal();
        },
        visualizarMapaDomicilios() {
            if(!this.visualizarMapaDomicilios) {
                this.visualizarErroresUbicacionEnMapa = false;
            }
        } */
    },
    computed: {
        empresa_entidad: {
            get() {
                return this.empresa;
            },
            set(val) {
                this.$emit('obtenerEmpresaObj', val);
            }
        },
        mostrar_errores: {
            get() {
                return this.mostrarErroresEnFormulario;
            },
            set(val) {
                this.$emit('obtenerMostrarErrores', val);
            }
        }
        /* nombre_empresa: {
            get() {
                return this.nombreEmpresa;
            },
            set(val) {
                this.$emit('obtenerNombreEmpresa', val);
            }
        },
        codigo_postal: {
            get() {
                return this.codigoPostal;
            },
            set(val) {
                this.$emit('obtenerCodigoPostal', val);
            }
        },
        numero_exterior: {
            get() {
                return this.numeroExterior;
            },
            set(val) {
                this.$emit('obtenerNumeroExterior', val);
            }
        },
        numero_interior: {
            get() {
                return this.numeroInterior;
            },
            set(val) {
                this.$emit('obtenerNumeroInterior', val);
            }
        },
        colonia_empresa: {
            get() {
                return this.colonia;
            },
            set(val) {
                this.$emit('obtenerColonia', val);
            }
        },
        municipio_colonia: {
            get() {
                return this.municipioFraccionamiento;
            },
            set(val) {
                this.$emit('obtenerFraccionamientoColonia', val);
            }
        },
        calle_empresa: {
            get() {
                return this.calle;
            },
            set(val) {
                this.$emit('obtenerCalle', val);
            }
        },
        informacion_adicional: {
            get() {
                return this.informacionAdicional;
            },
            set(val) {
                this.$emit('obtenerInformacionAdicional', val);
            }
        },
        nombre_representante: {
            get() {
                return this.nombreRepresentante;
            },
            set(val) {
                this.$emit('obtenerNombreRepresentante', val);
            }
        },
        apellido_paterno: {
            get() {
                return this.apellidoPaterno;
            },
            set(val) {
                this.$emit('obtenerApellidoPaterno', val);
            }
        },
        apellido_materno: {
            get() {
                return this.apellidoMaterno;
            },
            set(val) {
                this.$emit('obtenerApellidoMaterno', val);
            }
        },
        render_catalogo: {
            get() {
                return this.contadorRenderCatalogo;
            },
            set(val) {
                this.$emit('obtenerContRenderC', val);
            }
        } */
    }
}
</script>
<style scoped>

.contenedor-color-negro {
    padding: 1.5em;
    /* background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616; */
}

textarea {
    padding: 0.6em !important;
}

#contenedor-error-formulario {
    margin-top: 1.5em;
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.form-registro-empresas-sinoj .form-control {
    background-color: white !important;
    color: black !important;
}

.form-registro-empresas-sinoj h6,
.form-registro-empresas-sinoj h5,
.form-registro-empresas-sinoj h4 {
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CFormularioRegistroEmpresa.vue